export const TIMEOUT_MS = 60000;
export const MAX_RETRIES = 1;
export const RE_TRY_ABLE_ERRORS = ["ERR_NETWORK", "ERR_BAD_REQUEST"];

export const NON_RE_TRY_ABLE_ERRORS = [
  "404",
  "401",
  "429",
  "4014",
  "4001",
  "4003",
];

// For token refresh
export const REFRESH_BUFFER_SECONDS = 30; // Default buffer
